<template>
    <div class="nav no-print">

        <v-navigation-drawer mini-variant v-model="drawer" color="#5D337C" dark clipped fixed app>
            <v-list dense>

                <v-list-item @click="$router.push('/')">
                    <v-list-item-icon link>
                        <v-icon>trending_up</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Dashboard</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item @click="$router.push('/clients')">
                    <v-list-item-icon link>
                        <v-icon>view_headline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Clients</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item @click="$router.push('/activity-history')">
                    <v-list-item-icon link>
                        <v-icon>history</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Activity History</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item @click="$router.push('/content')">
                    <v-list-item-icon link>
                        <v-icon>format_list_bulleted</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Content</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-list>
            <template v-slot:append>
                <div class="pa-2">
                    <v-btn @click="logout()" block><v-icon>logout</v-icon></v-btn>
                </div>
            </template>
        </v-navigation-drawer>

        <v-app-bar app fixed clipped-left class="no-print" elevation="0">
            <v-app-bar-nav-icon v-if="!drawer" @click="drawer = !drawer" class="ml-1"><v-icon>chevron_right</v-icon></v-app-bar-nav-icon>
            <v-app-bar-nav-icon v-else @click="drawer = !drawer" class="ml-1"><v-icon>chevron_left</v-icon></v-app-bar-nav-icon>
            <v-toolbar-title @click="$router.push('/')"><img src="@/assets/logo.png" class="pt-2" width="110"></v-toolbar-title>
                            
            <v-spacer></v-spacer>

            <v-avatar v-if="currentUser" @click="userInfo()" size="35" dark color="green">
                <span style="color: #ffffff;">
                    {{ currentUser.short }}
                </span>
            </v-avatar>
        </v-app-bar>
    </div>
</template>
<script>
    import Vue from 'vue'
    import auth from 'firebase/auth'
    import firebase from 'firebase/app'
    export default {
        name: 'Navigation',
        components: {
        },
        computed: {
            currentUser(){
                return this.$store.getters.currentAdminUser
            }
        },
        data(){
            return {
                drawer: true
            }
        },      
        methods: {
            logout(){
                firebase.auth().signOut().then(() => {
                    this.$store.dispatch('logout')
                    this.$router.push('login')
                }).catch(function(error) {
                    console.log('unable to log out...')
                })
            }
        }
    }
</script>
<style>

@media print
{    
    .no-print, .no-print *
    {
        display: none !important;
    }
}

</style>